import React from "react";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import AppModal from "../../../Components/Models/app-modal";
import {
  Form,
  Button,
  Table,
  FormControl,
  InputGroup,
  ListGroup,
} from "react-bootstrap";
import api from "../../../Services/Api/api";
import { getFullName } from "../../../Modules/utils/fullname";

const SCREEN_NAME = "EDIT_TRANSACTION_SCREEN";

class EditTransactionInner extends AppComponent {
  constructor(props) {
    super(props);

    const collector = this.props.transaction
      ? this.props.transaction.collector
      : this.props.account?.collector;

    this.state = {
      amount: this.props.transaction?.amount || "",
      transactionType:
        this.props.transaction?.transactionType ||
        this.props.account?.accountType === "deposit"
          ? "deposit"
          : this.props.account?.accountType === "loan"
          ? "recovery"
          : "",
      side: this.props.transaction?.side || "debit",
      note: this.props.transaction?.note || "",
      t: this.props.transaction?.t || "",
      account: this.props.transaction?.account || this.props.account,
      accountQuery: "",
      collector: collector?._id || "",
    };
  }

  formRef = React.createRef(null);

  componentDidMount() {
    this.onMount();
    this.load();
  }

  async load() {
    try {
      const { agents } = await api.get("v1/agent", {
        queryStr: JSON.stringify({ limit: 0 }),
      });
      this.props.setScreenState({ agents }, false, "AGENTS_SCREEN");
    } catch (e) {
      this.setAsyncState({ error: e.message });
    }
  }

  async onSubmit() {
    try {
      if (this.state.loading) return;
      const isValid = this.formRef?.current?.reportValidity();
      if (!isValid) return;

      let payload = _.pick(this.state, [
        "amount",
        "transactionType",
        "side",
        "note",
        "t",
        "collector",
      ]);

      payload = {
        ...payload,
        accountsid: this.state.account?.shortId,
      };

      if (!payload.accountsid) {
        throw new Error("Please select an account");
      }

      this.setAsyncState({ loading: true, error: null });
      let res;
      if (this.props.transaction?._id) {
        throw new Error("Edit Transaction Not Allowed");
      } else {
        res = await api.post("v1/transaction", payload);
      }

      this.setAsyncState({ loading: false });
      this.props.onSubmit(res?.transaction);
    } catch (e) {
      this.setAsyncState({ error: e.message, loading: false });
    }
  }

  retriveAccountId = 0;
  async retriveAccounts(q) {
    try {
      let retriveAccountId = Date.now();
      this.retriveAccountId = retriveAccountId;

      let where = {};
      if (!q) {
        this.setAsyncState({ loadingAccounts: false, customers: [] });
        return;
      } else {
        where = {
          $or: [
            {
              shortId: { $regex: q, $options: "i" },
            },
          ],
        };
      }

      this.setAsyncState({ loadingAccounts: true });

      const { accounts } = await api.get("v1/account", {
        queryStr: JSON.stringify({
          where,
          limit: 10,
          populate: "customer",
        }),
      });

      if (this.retriveAccountId === retriveAccountId) {
        let updateObj = { accounts, loadingAccounts: false };
        if (accounts.length === 1) {
          updateObj = {
            accounts: [],
            loadingAccounts: false,
            account: accounts[0],
          };
        }
        this.setAsyncState(updateObj);
      }
      return accounts.map((x) => ({ ...x, value: x._id, label: x.fullName }));
    } catch (e) {
      console.error(e.message);
      this.setAsyncState({ loadingAccounts: false });
    }
  }

  searchAccountTimer = null;
  async searchAccount(q) {
    this.setAsyncState({ accountQuery: q });
    clearTimeout(this.searchAccountTimer);

    setTimeout(() => {
      this.retriveAccounts(q);
    }, 200);
  }

  renderForm() {
    const {
      props: { renderModal = false },
      state: {
        amount,
        side,
        transactionType,
        note,
        error,
        t,
        account,
        loadingAccounts,
        accountQuery,
        accounts,
        collector,
      },
    } = this;

    const isEditing = !!this.props.transaction?._id;
    const accountType = account?.accountType;

    if (account && !["loan", "deposit"].includes(accountType)) return null;

    return (
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          this.onSubmit();
        }}
        ref={this.formRef}
      >
        {/* <Form.Group className="mb-3">
          <Form.Label>Account Id</Form.Label>
          <Form.Control
            type="text"
            placeholder="Account ID"
            value={accountsid}
            onChange={(e) => this.setAsyncState({ accountsid: e.target.value })}
            required
            disabled={!!(isEditing || this.props.account?.shortId)}
          />
        </Form.Group> */}

        <Form.Group className="mb-3 select-customer-from-group">
          {account?._id ? (
            <div>
              {/* <Form.Label>Selected Account</Form.Label> */}
              <Table
                striped
                bordered
                hover
                size="sm"
                style={{ marginBottom: 0 }}
              >
                <tbody>
                  <tr>
                    <th>Account ID</th>
                    <td>{account?.shortId}</td>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <td>{getFullName(account?.customer)}</td>
                  </tr>
                  <tr>
                    <th>Account Type</th>
                    <td>{account?.accountType}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          ) : (
            <Form.Label>Select Account</Form.Label>
          )}

          {!isEditing && !this.props.account?._id ? (
            <>
              <InputGroup>
                <FormControl
                  placeholder="Search Existing Account"
                  value={accountQuery}
                  onChange={(e) => this.searchAccount(e.target.value)}
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => this.searchAccount(accountQuery)}
                >
                  Search
                </Button>
              </InputGroup>
              {loadingAccounts ? (
                <Form.Text className="text-muted">Loading...</Form.Text>
              ) : (
                <Form.Text className="text-muted">
                  Select account from search result
                </Form.Text>
              )}
              <ListGroup>
                {accounts?.map((item) => {
                  return (
                    <ListGroup.Item
                      key={item._id}
                      action
                      onClick={() =>
                        this.setAsyncState({
                          account: item,
                          accounts: [],
                          accountQuery: "",
                        })
                      }
                    >
                      <b>{item.shortId}</b>{" "}
                      {`(${item.accountType}) (${getFullName(item.customer)})`}
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </>
          ) : null}
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Amount</Form.Label>
          <Form.Control
            type="number"
            placeholder="Amount"
            value={amount}
            onChange={(e) => this.setAsyncState({ amount: e.target.value })}
            step={0.01}
            required
            min={0}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Transaction Type</Form.Label>
          <Form.Control
            as="select"
            value={transactionType}
            onChange={({ target: { value } }) =>
              this.setAsyncState({
                transactionType: value,
                side: ["toLoan", "withdraw"].includes(value)
                  ? "credit"
                  : ["less"].includes(value)
                  ? accountType === "deposit"
                    ? "credit"
                    : "debit"
                  : "debit",
              })
            }
            required
          >
            <option value="" disabled>
              Select
            </option>
            {(accountType === "loan"
              ? ["toLoan", "recovery", "less"]
              : accountType === "deposit"
              ? ["deposit", "withdraw", "less"]
              : []
            ).map((x) => (
              <option key={x} value={x}>
                {_.startCase(x)}
              </option>
            ))}
          </Form.Control>
          <Form.Text className="text-muted">
            Select Credit or Debit on customer's account
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Transaction Side</Form.Label>
          <Form.Control
            as="select"
            value={side}
            onChange={({ target: { value } }) =>
              this.setAsyncState({
                side: value,
              })
            }
            required
            disabled={["toLoan", "recovery", "deposit", "withdraw"].includes(
              transactionType
            )}
          >
            <option value="" disabled>
              Select
            </option>
            <option value="credit">Credit</option>
            <option value="debit">Debit</option>
          </Form.Control>
          <Form.Text className="text-muted">
            Select Credit or Debit on customer's account
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Note (optional)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Note"
            value={note}
            onChange={(e) => this.setAsyncState({ note: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Collector</Form.Label>
          <Form.Control
            as="select"
            value={collector?._id || collector || ""}
            onChange={(e) => this.setAsyncState({ collector: e.target.value })}
          >
            <option value="">No Collector</option>
            {this.props.agents?.map((x) => (
              <option key={x._id} value={x._id}>
                {getFullName(x)}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Transaction Time (optional)</Form.Label>
          <Form.Control
            type="datetime-local"
            value={t}
            onChange={(e) => this.setAsyncState({ t: e.target.value })}
          />
          <Form.Text className="text-muted">
            Transaction time should be greater than the last transaction.
          </Form.Text>
        </Form.Group>

        <div className="errormsg">{error}</div>

        {renderModal ? null : (
          <Button variant="primary" type="submit" disabled={!account?._id}>
            Submit
          </Button>
        )}
      </Form>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: this.props.transaction?._id
            ? "Edit Transaction"
            : "Record Transaction",
          onSubmit: this.onSubmit.bind(this),
          disableSubmit: this.state.loading || !this.state.account?._id,
        }}
      >
        {this.renderForm()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false },
    } = this;

    if (renderModal) return this.renderModal();
    else return this.renderForm();
  }
}

const mapStateToProps = (state) => ({
  agents: state.vState.AGENTS_SCREEN?.agents,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const EditTransaction = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditTransactionInner);

export default EditTransaction;
